<template>
  <div class='list-add'>
    <div class='add'>
      <div class='baseInfo'>

        <div class='baseInfoContent'>

          <el-form :model='modifyData' label-width='110px' label-position='right' :rules='rules'
                   ref='ruleForm' class='demo-ruleForm'>
            <div class='yang'>
              <div-border label='基础信息' prop='plan'>
                <el-form-item label='合同名称' prop='contractName' style='margin-top: 15px'>
                  <el-input v-model='modifyData.contractName' size='mini'></el-input>
                </el-form-item>
                <el-form-item label='签订合同编号:' prop='codeNumber'>
                  <el-input v-model='modifyData.codeNumber' size='mini'></el-input>
                </el-form-item>
                <el-form-item label='合同类型:' prop='typeId'>
                  <el-select v-model='modifyData.typeId' filterable size='mini' placeholder='请选择'
                             value-key='typeId'>
                    <el-option v-for='(item,index) in contactTypeList' :label='item.typeName'
                               :value='item' :key='`${index}a`'></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label='紧急程度' prop='urgent'>
                  <el-radio-group v-model='modifyData.urgent'>
                    <el-radio :label='1'>紧急</el-radio>
                    <el-radio :label='2'>急</el-radio>
                    <el-radio :label='3'>一般</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label='是否为主合同' prop='type'>
                  <el-radio-group v-model='modifyData.type'  @change="getContractId">
                    <el-radio :label= 0>是</el-radio>
                    <el-radio :label=1>否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label='主合同:' prop='contractId' v-if="modifyData.type ===1 ">
                  <el-select v-model='modifyData.contractId' filterable size='mini' placeholder='请选择主合同'
                             value-key='contractId' @change="getContract">
                    <el-option v-for='(item,index) in contactIdOption' :label='item.contractName' :value='item'
                               :key='`${index}zht`'></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label='签约单位类型' prop='companyTypeId'>
                  <el-radio-group v-model='modifyData.companyTypeId' @change='companyTypeChange'>
                    <el-radio v-for='(item,index) in companyTypeList' :label='item.companyTypeId'
                              :key='`${index}tr`'>{{ item.companyTypeName }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label='签订单位:' prop='companyId'>
                  <el-select v-model='modifyData.companyId' filterable placeholder='请选择' size='mini'
                             value-key='id'>
                    <el-option v-for='(item,index) in companyList' :label='item.name' :value='item'
                               :key='`${index}sds`'></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="年度标总额:" prop="totalYear">
                  <el-select v-model="modifyData.totalYear" filterable placeholder="请选择" size="mini" value-key="id">
                    <el-option v-for="(item,index) in totalYearOption" :label="item.classaName" :value="item" :key="item.id"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label='开始日期:' prop='startTime'>
                  <el-date-picker v-model='modifyData.startTime'
                                  type='datetime' placeholder='开始日期' size='mini'
                                  value-format='yyyy-MM-dd HH:mm:ss'
                                  default-time="00:00:00"/>
                </el-form-item>
                <el-form-item label='结束日期:' prop='endTime'>
                  <el-date-picker v-model='modifyData.endTime' type='datetime'
                                  placeholder='结束日期' size='mini'
                                  value-format='yyyy-MM-dd HH:mm:ss'
                                  default-time="23:59:59"/>
                </el-form-item>
                <el-form-item label='主要内容:' prop='content'>
                  <el-input
                    type='textarea'
                    :autosize='{ minRows: 2, maxRows: 4}'
                    placeholder='请输入内容'
                    v-model='modifyData.content' size='mini'>
                  </el-input>
                </el-form-item>
                <!--                <el-form-item label="备注:">-->
                <!--                  <el-input-->
                <!--                    type="textarea"-->
                <!--                    :autosize="{ minRows: 2, maxRows: 4}"-->
                <!--                    placeholder="请输入备注"-->
                <!--                    v-model="modifyData.content" size="mini">-->
                <!--                  </el-input>-->
                <!--                </el-form-item>-->
                <div class='bond'>
                  <div style='width: 100px' @click='bondFlag = true'>添加履约保证金</div>
                </div>
              </div-border>
              <!--              <div-border label='上传附件' :isNeed='true'>
                              <el-form-item style='margin-top:15px; ' label-width='50px'>
                                <div class='imgUp'>
                                  <div class='imgLength'><span>{{ modifyData.img.length }}/5</span></div>
                                  <el-upload
                                    ref='upload'
                                    class='upload-demo'
                                    :action='uploadUrl'
                                    :auto-upload='true'
                                    accept='image/png, image/jpeg, image/jpeg, image/bmp, image/gif'
                                    :before-upload='beforeAvatarUpload'
                                    :on-change='uploadChange'
                                    :on-remove='handleRemove'
                                    :on-preview='handlePictureCardPreview'
                                    :file-list='modifyData.img'
                                    :limit='5'
                                  >
                                    <i class='el-icon-plus' />
                                  </el-upload>
                                </div>
                              </el-form-item>
                            </div-border>-->
              <div-border label='履约保证金' v-if='bondFlag'>
                <i class='el-icon-close icon-close' @click='bondFlag = false'></i>
                <el-form-item label='履约保证金额' style='margin-top:15px' prop='bond'>
                  <el-input v-model='modifyData.bond' size='mini'></el-input>
                </el-form-item>
                <el-form-item label='缴纳方式' prop='mode'>
                  <el-input v-model='modifyData.mode' size='mini'></el-input>
                </el-form-item>
              </div-border>
              <div-border label='上传附件' :isNeed='true' style='padding-top:15px;'>
                <!--                <el-form-item label='查看附件人：' v-if='modifyData.img && modifyData.img.length >0'>
                                  <div class='enclosure'>
                                    <div>{{ modifyData.fileUserName }}</div>
                                    <div class='enclosureAdd' @click='enclosureAdd'>添加</div>
                                  </div>
                                </el-form-item>-->
                <el-form-item>
                  <div class='imgUp'>
                    <el-upload
                      ref='upload'
                      class='upload-demo'
                      accept='image/*,.pdf'
                      :action='uploadUrl'
                      :auto-upload='true'
                      :before-upload='beforeAvatarUpload'
                      :show-file-list='false'
                      :data='uploadData'
                      :on-change='uploadChange'
                      :on-success='(res) => uploadImgFun(res, 2)'
                      :file-list='modifyData.img'
                      :limit='1'
                    >
                      <el-button size='small' type='primary'>点击上传</el-button>
                      <div slot='tip' style='margin-top: 6px;margin-left: 10px'>支持扩展名：.pdf .jpg
                        .jpeg .png
                      </div>
                    </el-upload>
                    <div v-for='(item,index) in modifyData.img'>
                      <div class='upload'>
                        <div
                          style='white-space:nowrap; text-overflow:ellipsis;overflow:hidden;width: 360px'>
                          {{ item.name }}
                        </div>
                        <div>
                          <i class='el-icon-loading' v-if="item.status !=='success'"></i>
                          <i class='el-icon-zoom-in pointer'
                             @click='handlePictureCardPreview(item,index)'
                             v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                          <i class='el-icon-upload2 pointer' @click='uploadClick(item,index)'></i>
                          <i class='el-icon-delete pointer' @click='handleRemove(item,index)'></i>
                        </div>
                      </div>
                    </div>

                  </div>
                </el-form-item>
              </div-border>
            </div>
          </el-form>
          <div class='btnContainer'>
            <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>
              {{ dilogNumber === 1 ? '添加' : '修改' }}
            </el-button>
            <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
          </div>
        </div>

      </div>
      <el-dialog :visible.sync='dialogVisible' append-to-body title='图片查看' center>
        <img width='100%' :src='dialogImageUrl' alt=''>
      </el-dialog>

    </div>
    <el-dialog :visible.sync='enclosureFlag' center append-to-body title='选择查看附件人员'>
      <enclosureAdd ref='enclosure'
                    @enclosureClick='transmit'
                    @eClose='enclosureClose'
                    :depId='modifyData.depId'
                    :peopleList='modifyData.peopleList'></enclosureAdd>
    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl,
  } from '@/config/env';
  import uploadImg from '@/components/uploadImg';
  import divBorder from '@/components/divBorder';
  import enclosureAdd from './enclosureAdd';
  import {
    contractTypeSelectList,
    contractAdd,
    contractGetContractType,
    contractDetail,
    contractUpdate, contractIdSelectList,
  } from '@/service/contract';
  import {
    customerInfoSelectList, getParam,
  } from '@/service/getData';
  import { supplierListSelectPort } from '@/service/vehiclelog';
  import { highwayLineSelectList, highwayLineSelectWaterSupplier } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    components: {
      uploadImg,
      divBorder,
      enclosureAdd,
    },
    props: ['dilogNumber', 'id'],
    data() {
      return {
        uploadData: {
          fileType: '0',
        },
        modifyData: {
          companyTypeId: '',//签约单位类型名称id
          codeNumber: '',
          typeId: '',
          content: '',
          startTime: '',
          endTime: '',
          companyId: '',
          contractName: '',
          depId: '',//部门id
          // totalYear:"",
          urgent: 1,
          type: 0, //是否为主合同
          contractId: '',//主合同
          bond: '',//履约保证金
          mode: '',//缴纳方式
          img: [],
          fileUserName: '',//附件人名字，逗号隔开
          fileUserId: '',//附件人id，逗号隔开
          fileId: '',//文件id逗号隔开
        },
        totalYearOption: [],//年度标总额
        operationData: [
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '启用',
            account: '王三文',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '禁用',
            account: '张三丰',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '添加',
            account: '赵兮雪',
            remark: '',
          },
        ],
        baseImgUrl: baseImgUrl + '/',
        uploadUrl: '',
        uploadFlag: false,//替换
        uploadIndex: '',//替换索引
        dialogVisible: false,
        addLoad: false,
        dialogImageUrl: '',
        //存储成功回调附件地址
        dialogImageUrlList: [],
        enclosureFlag: false,//查看附件人添加
        bondFlag: false,
        contactTypeList: [{
          typeId: 'sdsf',
          typeName: 'zhou',
        }],
        contactIdOption: [],//主合同下拉框
        companyTypeList: [
          {
            companyTypeId: 1,
            companyTypeName: '委托商',
          },
          {
            companyTypeId: 2,
            companyTypeName: '公路供应商',
          },
          {
            companyTypeId: 3,
            companyTypeName: '水路供应商',
          },
          {
            companyTypeId: 4,
            companyTypeName: '港口及其他',
          },
        ],
        companyList: [
          {
            companyId: '23233',
            companyName: 'zhi',
          },
          {
            companyId: '748737',
            companyName: 'shi',
          },
        ],
        rules: {
          plan: {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
          contractName: [
            {
              required: true,
              message: '请输入合同名称',
              trigger: 'blur',
            },
            // { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
          ],
          typeId: {
            required: true,
            message: '请选择合同类型',
            trigger: 'blur',
          },
          companyId: {
            required: true,
            message: '请选择签约单位',
            trigger: 'blur',
          },
          content: {
            required: true,
            message: '请输入合同主要内容',
            trigger: 'blur',
          },
          codeNumber: [
            {
              required: true,
              message: '请输入签订合同编号',
              trigger: 'blur',
            },
            {
              pattern: /^[A-Za-z0-9-]+$/,
              message: '请输入正确签订合同编号',
            },
          ],
          startTime: {
            required: true,
            message: '请选择合同起始日期',
            trigger: 'blur',
          },
          endTime: {
            required: true,
            message: '请选择合同结束日期',
            trigger: 'blur',
          },
          img: {
            required: true,
            message: '请选择合同照片',
            trigger: 'blur',
          },
          // totalYear:{required: true, message: '请选择年度标总额', trigger: 'blur'},
          urgent: {
            required: true,
            message: '请选择签订价格',
            trigger: 'blur',
          },
          type: {
            required: true,
            message: '请选择是否为主合同',
            trigger: 'blur',
          },
          contractId: {
            required: true,
            message: '请选择主合同',
            trigger: 'blur',
          },
          companyTypeId: {
            required: true,
            message: '请选择签约单位类型',
            trigger: 'blur',
          },
          bond: {
            required: true,
            message: '请输入履约保证金额',
            trigger: 'blur',
          },
          mode: {
            required: true,
            message: '请输入缴纳方式',
            trigger: 'blur',
          },
        },
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
        this._contractTypeSelectList();
        // if (this.dilogNumber !==1) this._modifyDetail()

      },
      getContractId(value) {
        if (value === 1) {
           this.getContractIds()
        }
      },
      getContract(val){
        console.log(val)
      },
      async getContractIds() {
        let res = await  contractIdSelectList();
        if (res.status !== null && res.status !== 0) return this.$message.error(res.message);
        this.contactIdOption = res.data.map((item) =>{
          return {
            contractName: item.contractName,
            contractId: item.id,
            codeZ: item.codeNumber
          }
        })
      },
      async _contractTypeSelectList() {
        let res = await contractTypeSelectList({ contractTypeName: '' });
        if (res.status !== 0) return this.$message.error(res.message);
        this.contactTypeList = res.data.map((item) => {
          return {
            typeName: item.contract_name,
            typeId: item.id,
          };
        });
      },
      async _customerInfoSelectList() {
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) return this.$message.error(res3.message);
        this.companyList = res3.data.map(item => {
          return {
            name: item.customer_name,
            id: item.id,
          };
        });

      },
      async _highwayLineSelectList() {
        let res = await highwayLineSelectList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data.map(item => {
          return {
            name: item.name,
            id: item.id,
          };
        });
      },
      async _highwayLineSelectWaterSupplier() {
        let res = await highwayLineSelectWaterSupplier();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data;
      },
      async _shipDeployPublicSelectPort() {
        let res = await supplierListSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data.map(item => {
          return {
            name: item.supplier_name,
            id: item.id,
          };
        });
      },
      async _getParam() {
        let res = await getParam({ categoryCd: 'contract_total' });
        if (res.status !== 0) return this.$message.error(res.message);
        this.totalYearOption = res.data;
      },
      // async getContractIdList() {
      //   let res = await contractIdSelectList();
      //   if (res.status !== 0) return this.$message.error(res.message);
      //   this.contactIdList = res.data
      //   console.log(this.contactIdList)
      // },
      async _modifyDetail() {
        let res = await contractDetail(this.id);
        if (res.status !== 0) return this.$message.error(res.message);
        let {
          companyType,
          codeNumber,
          margin,
          marginType,
          companyId,
          companyName,
          startDate,
          endDate,
          typeId,
          typeName,
          attachments,
          totalYearId,
          totalYearName,
          content,
          addPeopleName,
          contractName,
          urgent,
          type,
          addPeopleId,
          contractNameZ,
          contractId,
          codeZ
        } = res.data;
        //判断是否有履约保证金
        if (margin && marginType) this.bondFlag = true;
        //数据回显
        this.modifyData = {
          ...res.data,
          companyTypeId: companyType,//签约单位类型
          codeNumber: codeNumber,
          typeId: {
            typeId: typeId,
            typeName: typeName,
          },
          // startTime:[startDate,endDate],
          startTime: startDate,
          endTime: endDate,
          companyId: {
            id: companyId,
            name: companyName,
          },
          // totalYear:{id:totalYearId,classaName:totalYearName},
          fileId: '',
          fileUserName: addPeopleName,//附件人名称
          fileUserId: addPeopleId,//附件人id
          contractName: contractName,//合同名称
          urgent: urgent,//紧急程度
          type: type,//是否为主合同
          content: content,
          contractId: {
            contractName: contractNameZ,
            contractId: contractId,
            codeZ: codeZ
          },//主合同
          bond: margin,//履约保证金
          mode: marginType,//缴纳方式
          img: [],
        };
        let token = getSessionStore('token');
        //根据签约单位类型,查询签约单位
        await this.companyTypeChange(companyType);
        await this.getContractIds()
        let array = attachments ? attachments.map(item => {
          return {
            name: item.attachmentName,
            url: baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token,
            status: 'success',
            id: item.id,
            uploadTime: item.uploadTime,
          };
        }) : [];
        console.log(array);
        this.$set(this.modifyData, 'img', array);
        // let res2 =await contractGetContractType(companyTypeId)
        // this.companyList = res2.data.map((item)=>{
        //   return{
        //     companyId:item.id,
        //     companyName:item.name
        //   }
        // })
      },
      //签订单位查询
      async companyTypeChange(value) {
        if (this.dilogNumber === 1) this.modifyData.companyId = '';
        // let res =await contractGetContractType(value.companyTypeId)
        // this.companyList = res.data.map((item)=>{
        //   return{
        //     companyId:item.id,
        //     companyName:item.name
        //   }
        // })
        console.log(value);
        //签约单位类型  1 委托商 2 公路 3 水路 4 港口
        switch (value) {
          case 1:
            await this._customerInfoSelectList();
            break;
          case 2:
            await this._highwayLineSelectList();
            break;
          case 3:
            await this._highwayLineSelectWaterSupplier();
            break;
          case 4:
            await this._shipDeployPublicSelectPort();
            break;

        }
      },
      beforeAvatarUpload(file) {
        // const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
        // const isJPG =TypeArr.includes(file.type)
        const isLt10M = file.size / 10024 / 10024 < 10;
        // if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');

        // return isJPG && isLt10M
        return isLt10M;
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) { //判断是否是替换
          this.modifyData.img.splice(this.uploadIndex, 1, file);
        } else {
          this.modifyData.img = fileList;
          console.log(fileList);
        }
        //上传是否成功，上传失败就删除
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status == -1) {
            this.modifyData.img.splice(this.modifyData.img.indexOf(file), 1);
          }
        }

      },
      //附件上传成功回调
      uploadImgFun(res, val) {
        if (res.status == 0) {
          this.$message.success(res.message);
          if (this.uploadFlag) {//如果为替换，得到索引值进行替换
            this.dialogImageUrlList.splice(this.uploadIndex, 1, { 'id': res.data.id });
            console.log(this.dialogImageUrlList);
            this.uploadFlag = false;
          } else {
            this.dialogImageUrlList.push({ 'id': res.data.id });
            console.log(this.dialogImageUrlList);
          }

        } else {
          this.$message.error(res.message);
          this.uploadFlag = false;

        }
      },
      //外部图片删除
      handleRemove(item, index) {
        this.modifyData.img.splice(index, 1);
      },

      // loadFile(id) {
      //   axios({
      //     method: 'post',
      //     url: baseUrl +`/web/attachmentFtp/download?attachmentId=${id}`,
      //     responseType: 'blob',
      //     params: {},
      //     headers: {
      //       Accept: 'application/octet-stream',
      //       token: getSessionStore('token'),   // 获取token，这里假定 myToken
      //     },
      //   }).then(res => {
      //     let blob = new Blob([res.data], {type: 'image/jpeg'});
      //     const imageUrl = URL.createObjectURL(blob);
      //     this.dialogImageUrl = imageUrl;
      //     this.srcList.push(imageUrl);
      //   }).catch(err => {
      //     console.log('导出失败')
      //   })
      // },
      //外部图片查看
      async handlePictureCardPreview(item, index) {
        console.log(item);
        //判断是否有响应参数（修改回显参数没有上传成功响应参数
        let token = getSessionStore('token');
        this.dialogImageUrl = baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token;
        console.log(this.dialogImageUrl);
        this.dialogVisible = true;
      },
      //外部上传方法，替换
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();

      },

      addClick() {
        this.$refs.ruleForm.validate(async (valid) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            // 1 为添加 2 修改
            if (this.dilogNumber === 1) {
              //附件id用逗号隔开
              this.modifyData.img.forEach((item, index) => {
                if (this.modifyData.img.length - 1 === index) {
                  this.modifyData.fileId += item.response.data.id;
                } else {
                  this.modifyData.fileId += item.response.data.id + ',';
                }
              });
              this.addLoad = true;
              let {
                companyTypeId,
                typeId,
                startTime,
                endTime,
                companyId,
                bond,
                mode,
                fileUserId,
                fileId,
                type,
                contractId
              } = this.modifyData;
              let data = {
                ...this.modifyData,
                // companyTypeId:companyTypeId.companyTypeId,
                // companyTypeName:companyTypeId.companyTypeName,
                companyType: parseInt(companyTypeId),
                typeId: typeId.typeId,
                typeName: typeId.typeName,
                startDate: startTime,
                endDate: endTime,
                companyId: companyId.id,
                companyName: companyId.name,
                // totalYearId:totalYear.id,
                // totalYearName:totalYear.classaName,
                empId: fileUserId,
                margin: bond,
                marginType: mode,
                isMargin: this.bondFlag ? '1' : '0',
                attachmentIdStr: fileId,
                type: type,
                contractId:  contractId.contractId,
                codeZ: contractId.codeZ,
                contractNameZ: contractId.contractName
              };
              let res = await contractAdd(data);
              this.addLoad = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              console.log('添加');
            } else {
              //附件id用逗号隔开
              this.modifyData.fileId = '';
              this.modifyData.img.forEach((item, index) => {
                //判断是否是最后一个，最后一个不加逗号
                if (this.modifyData.img.length - 1 === index) {
                  this.modifyData.fileId += item.response ? item.response.data.id : item.id;
                } else {
                  this.modifyData.fileId += item.response ? item.response.data.id + ',' : item.id + ',';
                }

              });
              this.addLoad = true;
              let {
                companyTypeId,
                typeId,
                startTime,
                endTime,
                companyId,
                bond,
                mode,
                fileUserId,
                fileId,
                type,
                contractId
              } = this.modifyData;
              let data = {
                ...this.modifyData,
                companyType: parseInt(companyTypeId),
                typeId: typeId.typeId,
                typeName: typeId.typeName,
                startDate: startTime,
                endDate: endTime,
                companyId: companyId.id,
                companyName: companyId.name,
                // totalYearId:totalYear.id,
                // totalYearName:totalYear.classaName,
                empId: fileUserId,
                margin: bond,
                marginType: mode,
                isMargin: this.bondFlag ? '1' : '0',
                attachmentIdStr: fileId,
                type: type,
                contractId:  contractId.contractId,
                codeZ: contractId.codeZ,
                contractNameZ: contractId.contractName
              };
              let res = await contractUpdate(data);
              this.addLoad = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              console.log('修改');
            }
            //触发父组件函数 并传参
            this.$emit('addclose', false);
            this.bondFlag = false;
            for (const argumentsKey in this.modifyData) {
              if (argumentsKey == 'img') {
                this.modifyData[argumentsKey] = [];
              } else {
                this.modifyData[argumentsKey] = '';
              }

            }


          } else {
            return false;
          }
        });
      },
      dialogClose() {
        //清空提示
        this.$refs.ruleForm.resetFields();
        //数据清空
        for (const argumentsKey in this.modifyData) {
          if (argumentsKey == 'img') {
            this.modifyData[argumentsKey] = [];
          } else {
            this.modifyData[argumentsKey] = '';
          }

        }
        this.bondFlag = false;
        this.$emit('addclose', false);
      },
      enclosureAddClose() {
        this.modifyData.depId = this.$refs.enclosure.department.id;
        let checkedCities = this.$refs.enclosure.checkedCities;
        this.modifyData.fileUserName = '';
        this.modifyData.fileUserId = '';
        checkedCities.forEach((item, index) => {
          console.log(item);
          this.modifyData.fileUserName += checkedCities.length - 1 === index ? item.name : item.name + ',';
          this.modifyData.fileUserId += checkedCities.length - 1 === index ? item.id : item.id + ',';
        });
        this.$refs.enclosure.checkedCities = '';
        this.$refs.enclosure.isIndeterminate = true;
        this.$refs.enclosure.checkAll = false;
        console.log(this.modifyData);
      },
      //查看附件人 子组件触发函数
      transmit(data) {
        let {
          depId,
          fileUserName,
          fileUserId,
          peopleList,
        } = data;
        this.modifyData.fileUserName = fileUserName;
        this.modifyData.fileUserId = fileUserId;
        this.modifyData.peopleList = peopleList;
        this.modifyData.depId = depId;
        this.enclosureFlag = false;
      },
      enclosureClose() {
        this.enclosureFlag = false;
        this.bondFlag = false;
      },
      enclosureAdd() {
        console.log(this.modifyData.depId, 'add');
        this.enclosureFlag = !this.enclosureFlag;
        this.$nextTick(() => {
          // 触发子组件函数
          this.$refs.enclosure._qryDepartment();
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$refs.enclosure.depNameChange(this.modifyData.depId);
          }, 500);

        });
      },
      enclosureAddData() {

      },

    },
  };
</script>

<style lang='scss' scoped>
  .list-add {
    ::v-deep .add {

      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 15px;
              /*.el-input__inner{*/
              /*  border: none;*/
              /*}*/
              .el-form-item__label {
                width: 150px !important;
                /*color: #060606;*/
              }

              .el-input {
                width: 430px;
              }

              .el-textarea {
                width: 250px;
              }
            }

            .icon-close {
              font-size: 21px;
              position: absolute;
              top: 5px;
              right: 9px;
            }

            .icon-close:hover {
              cursor: pointer;
              color: #3388FF;;
            }
          }

          /*.el-upload-list__item{*/
          /*  width: 100px;*/
          /*  height: 100px;*/
          /*}*/
          /*.el-upload--picture-card{*/
          /*  width: 100px;*/
          /*  height: 100px;*/
          /*  line-height: 100px;*/
          /*}*/
          .imgUp {
            /*display: flex;*/
            /*flex-direction: column;*/
            /*.imgLength{*/
            /*  display: flex;*/
            /*  align-items: center;*/
            /*  width:100%;*/
            /*  span{*/
            /*    margin-left:auto;*/
            /*    color: rgb(183, 183, 183);*/
            /*    font-size: 16px;*/
            /*  }*/
            .upload-demo {
              display: flex;
            }

            .upload {
              font-size: 17px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              i {
                margin-right: 10px;
              }

              i:hover {
                color: #00e1ff;
              }
            }
          }

          .bond {
            color: #3388FF;
            text-align: end;
            display: flex;
            justify-content: flex-end;

          }

          .bond div:hover {
            color: #335483;
            cursor: pointer;
          }

          .enclosure {
            display: flex;

            .enclosureAdd {
              margin-left: 20px;
              color: #3388FF;
              text-decoration: underline;

              &:hover {
                cursor: pointer;
              }

            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }
  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog {
      margin-top: 28vh !important;
    }

    .el-dialog__title {
      /*line-height: 24px;*/
      color: #FFFFFF;

      font-weight: 700;
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 70vh;

      color: #606266;
    }

  }

  .imgUp {
    .upload-demo {
      display: flex;
    }

    .upload {
      font-size: 17px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      i {
        margin-right: 10px;
      }

      i:hover {
        color: #00e1ff;
      }
    }
  }
</style>
